import { api } from "@/lib/apiClient";
import type { CurrentUser } from "@/types/user";

const ROLE_LABELS: Record<string, string> = { user: "利用者", manager: "承認者", admin: "管理者" };

export function Header({ user }: { user: CurrentUser }) {
  const logout = async () => {
    await api.post("/auth/logout");
    window.location.reload();
  };

  return (
    <header
      className="app-header"
      style={{
        height: "var(--header-height)",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 12,
        padding: "0 24px",
        borderBottom: "1px solid var(--color-border)",
        background: "var(--color-surface)",
      }}
    >
      <span style={{ fontSize: 13, color: "var(--color-text-muted)" }}>
        {user.displayName}（{ROLE_LABELS[user.role]}）
      </span>
      <button
        onClick={logout}
        style={{
          background: "none",
          border: "none",
          color: "var(--color-text-muted)",
          fontSize: 13,
          textDecoration: "underline",
          height: 32,
        }}
      >
        ログアウト
      </button>
    </header>
  );
}
